<a class="{{logoClass}}" routerLink="/home">
	<img [src]="path" width="200"  alt="logo">
</a>
